export const PROVIDER_SHEET_GRID_CLASS = "grid-cols-2";

export const PROVIDER_DIALOG_GRID_CLASS =
    "grid-cols-4 lg:grid-cols-5 xl:grid-cols-6";
